<template>
	<router-view />
</template>
<script>
	import lenye_base from 'lenye_base'
	
	export default {
		created() {
			const apiServerUrl = process.env.VUE_APP_LYAI_JUHEAPI
			if (process.env.NODE_ENV === 'production') {
				lenye_base({
					api: apiServerUrl,
					domain: window.location.host,
					root: true
				})
			} else {
				lenye_base({
					api: apiServerUrl,
					domain: 'jxaqy.learnyeai.com',
					root: true
				})
			}
		}
	}
</script>
<style>
	.el-input-group--append .el-input__inner,
	.el-input-group__prepend {
		border-radius: 0;
		background-color: #3f474e;
		color: #fff;
		border: 0;
	}

	.el-input-group--prepend .el-input__inner,
	.el-input-group__append {
		border-radius: 0;
		background-color: #3f474e;
		color: #fff;
		border: 0;
	}

	.el-input__inner {
		border: 0;
		border-radius: 0px;
		height: 100%;
		background-color: #3f474e;
		color: #fff;
	}

	.el-form--label-top .el-form-item__label {
		display: none;
	}

	.el-input--mini .el-input__inner,
	.el-select {
		height: 100%;
		width: 100%;
		max-width: 780px;
	}

	.el-input-group__prepend .el-select {
		width: 80px;
	}

	.el-input-group,
	.el-input {
		height: 100%;
		background-color: #3f474e;
		color: #fff;
		border: 1 solid #3F474E;
	}

	.control-sidebar {
		right: -350px;
		width: 350px;
	}

	.el-cascader-panel {
		height: 200px;
	}

	.el-table .cell {
		line-height: 40px;
	}

	.scrollbar::-webkit-scrollbar {
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	.scrollbar::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #7f7f7f;
	}

	.scrollbar::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ededed;
	}
	
	.el-input__prefix, .el-input__suffix {
	    top: 8px;
	}
</style>
